import { executeRequest, JFSRequest } from '@jfs/network'
import { jsonToGraphQLQuery } from 'json-to-graphql-query'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, sitConfig } from './config'

const responseParser = (response: any) => {
  return response?.data?.data
}

const searchConfigRequest = (entityId: string) => {
  const queryObj = {
    searchEntityConfig: {
      __args: {
        entityId: entityId,
        configType: 'ALL',
        configStatus: 'ACTIVE',
        configListKey: 'ALL',
        configListStatus: 'ACTIVE',
      },
      entityConfig: {
        configType: true,
        key: true,
        value: true,
        status: true,
        configValuesReferenceId: true,
      },
      entityConfigList: {
        key: true,
        value: true,
        status: true,
        configValuesReferenceId: true,
      },
    },
  }

  const query = `{${jsonToGraphQLQuery(queryObj, { pretty: false })}}`
  console.log('fetchDevicesGqlReq query', query)
  return query
}

const searchConfigEntityReq = (entityId: string, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: APIEndPoints.searchConfigFromEms,
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: searchConfigRequest(entityId),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { searchConfigEntityReq }
